import React from 'react';
import cx from 'classnames';
import VerticalOneColumnProps from './VerticalOneColumn.types';
import styles from './VerticalOneColumn.module.scss';

const VerticalOneColumn = ({ header, footer, children, smallerSpacing = false }: VerticalOneColumnProps) => (
  <div className={styles.pageLayout}>
    <header className={styles.header}>{header}</header>
    <main className={cx(styles.main, { [styles.zeroTopMargin]: smallerSpacing })}>{children}</main>
    <footer className={styles.footer}>{footer}</footer>
  </div>
);

export default VerticalOneColumn;
